import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { PadContainer, HorizontalFlex } from 'smartsuite-ui';

function LinkList({ links }) {
    return (
        <PadContainer cssClassModifiers={['pad-small', 'no-pad-top']}>
            {links.map(link => (
                <PadContainer
                    key={link.displayText}
                    cssClassModifiers={['pad-medium', 'no-pad-top']}
                >
                    <HorizontalFlex>
                        {link.icon && (
                            <PadContainer
                                cssClassModifiers={[
                                    'pad-medium',
                                    'no-pad-top-bottom',
                                    'no-pad-left'
                                ]}
                            >
                                <span className={link.icon} />
                            </PadContainer>
                        )}
                        <a href={link.uri} target={link.target}>
                            {link.displayText}
                        </a>
                    </HorizontalFlex>
                </PadContainer>
            ))}
        </PadContainer>
    );
}

LinkList.propTypes = {
    links: PropTypes.instanceOf(Array).isRequired
};

export default React.memo(
    LinkList,
    (prevProps, nextProps) =>
        _.isEqual(prevProps.value, nextProps.value) &&
        _.isEqual(prevProps.threshold, nextProps.threshold)
);
